
import Translater from "./components/Translater";
function App() {
  return (
    <Translater />
  );
}

export default App;
